var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import { MenuItem } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import MenuActions from "../../shared/MenuActions";
var RecognitionActions = /** @class */ (function (_super) {
    __extends(RecognitionActions, _super);
    function RecognitionActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecognitionActions.prototype.render = function () {
        var _a = this.props, recognition = _a.recognition, onClickEdit = _a.onClickEdit, onClickRemove = _a.onClickRemove, onClickArchive = _a.onClickArchive, props = __rest(_a, ["recognition", "onClickEdit", "onClickRemove", "onClickArchive"]);
        return (React.createElement(MenuActions, __assign({ item: recognition }, props), function (_a) {
            var isUserContent = _a.isUserContent, isAdmin = _a.isAdmin;
            return ([
                isUserContent && !recognition.moderated && (React.createElement(MenuItem, { key: 1, onSelect: onClickEdit },
                    React.createElement(FormattedMessage, { id: "recognition.popup.recognition.actions.edit" }))),
                isAdmin && (React.createElement(MenuItem, { key: 2, onSelect: onClickArchive },
                    React.createElement(FormattedMessage, { id: "recognition.popup.recognition.action.archive" }))),
                !isUserContent && !recognition.moderated && isAdmin && (React.createElement(MenuItem, { key: 3, onSelect: onClickRemove },
                    React.createElement(FormattedMessage, { id: "recognition.popup.recognition.action.remove" })))
            ]);
        }));
    };
    return RecognitionActions;
}(Component));
export default RecognitionActions;
